import LocalizedStrings from "react-localization";

const Strings = {
  en: {
    GOOD_MORNING: "Good Morning",
    GOOD_AFTERNOON: "Good Afternoon",
    GOOD_EVENING: "Good Evening",
    IM_SURE:"I`m Sure",
    YES_PLEASE:"Yes, please",
    LOGIN_IMAGE_TITLE:"Smarter Parking Solutions",
    CONFIRM:"Confirm",
    YES: "Yes",
    NO: "No",
    OK: "Ok",
    SORRY: "Sorry",
    TRY_AGAIN: "Try Again",
    RELOAD: "Reload",
    SKIP: "Skip",
    RESET: "Reset",
    SAVE_AND_CONTINUE: "Save & Continue",
    CONFIRM_AND_CONTINUE:"Confirm and Continue",
    CANCEL:"Cancel",
    NOT_AVAILABLE: "N/A",
    CONFIRM_VERIFY:"Confirm and Verify",
    VERIFY: "Verify",
    DOWNLOAD: "Download",
    CHANGE:"Change",
    SEARCH:"Search",
    VALIDATE:"Validate",
    FILE_SIZE_KB: "KB",
    EXISTING_FILE_NAME: "File",
    PARKERS: "Parkers",
    MAILING_LISTS: "Mailing Lists",
    VALID_RECIPIENTS: "Valid Recipients",
    INVALID_RECIPIENTS: "Invalid Recipients",
    VIEW_PARKERS: "View parkers",
    VIEW_VALID_RECIPIENTS: "View valid recipients",
    VIEW_INVALID_RECIPIENTS: "View invalid recipients",
    MESSAGING_SUBSCRIBED: "Subscribed to messaging",
    MESSAGING_UNSUBSCRIBED: "Unsubscribed from messaging",
    SUBSCRIBED: "Subscribed",
    UNSUBSCRIBED: "Unsubscribed",
    DETAILS: "Details",
    CAMPAIGN_DETAILS: "Campaign Details",
    CAMPAIGN_PRICE: "Campaign Price",
    RECIPIENTS: "Recipients",
    SENT_BY: "Sent by",
    CREATED_BY: "Created by",
    NAME_IN_SITE: "{0} in {1}",
    DATE_SENT: "Date Sent",
    DATE_CREATED: "Date Created",
    EMAILS_NUMBER: "Number of emails",
    TEXT_MESSAGES_NUMBER: "Number of text messages",
    EMAILS_COST: "Cost per email",
    TEXT_MESSAGES_COST: "Cost per text message",
    REVIEW_SEND_CAMPAIGN: "Review & Send Campaign",
    READY_TO_SEND: "Ready to send?",
    READY_TO_SEND_CAMPAIGN: "Ready to send your campaign?",
    ARE_YOU_SURE: "Are you sure?",
    DELETE_MESSAGE:"Are you sure you would like to delete {0}?",
    UNASSIGN_MESSAGE:'Are you sure you would like to unassign "{0}" from the user?',
    TOKEN_OCCUPIED_MESSAGE:'Assigned to:{0} \n Are you sure you want to assign it also to this user?',
    ERROR_MESSAGE:"Sorry, \n We are experiencing an internal error \n Please try again later",
    ADD_CAR_BUTTON:"Add an additional car",
    ADD_RATE_BUTTON: "Add New Rate",
    ASSIGN_SUGGEST: "Would you like to assigned for",
    FOB_SKIPPED: "Fob Skipped",
    SCAN_FOB_SUCCESS: "Scanned Successfully Fob",
    SCAN_NEW_FOB_BUTTON:"Scan New FOB",
    ADD_NEW_USER_BUTTON:"Add New User",
    ADDITIONAL_PARKING_ALLOCATION_BUTTON:"Additional Parking Allocation",
    COMPLETED: "Completed",
    NEXT:"Next",
    BACK:"Back",
    ENTRANCE: "Entrance",
    EXIT: "Exit",
    CLOSE: "Close",
    DELETED: "Deleted",
    LICENSE_PLATE: "License Plate",
    TOTAL: "Total",
    FOB: "FOB",
    CLICK_HERE: "Click here",
    ADD_USER_TYPE: "To add new user type",
    ADD_PARKER:"Add Parker",
    SAVE:"Save",
    SAVE_CHANGES:"Save Changes",
    SAVE_LIST: "Save List",
    INVITE:"Invite",
    NO_CAR_SUBSCRIBED: "No Car Subscribed",
    TICKET_FOUND: "Ticket Found",
    ALLOCATION_DIFFERENT_USER_TYPE: "Cannot add the parking allocation, \nBoth parkers must have the same user type",
    NO_FREE_PARKING_ALLOCATIONS_WERE_FOUND: "No free parking allocations were found",
    NO_PARKING_ALLOCATION_WAS_FOUND: "No parking allocation was found",
    ASSIGNED_PARKING_ALLOCATIONS:"Assigned Parking Allocations",
    ASSIGNED_PARKERS_AND_FOBS: "Assigned Parkers & Fobs",
    SEARCH_USER_VALIDATE: "Search user to validate",
    CHARGING_POSITION: "Choose charging port location",
    CHARGING_PORT_SELECTED: "Selected port location",
    VALIDATION_OPTION: "Choose validation option",
    CHANGE_PASSWORD_MESSAGE:"In order to change the password, please enter the rellevant details",
    SEARCH_EXSISTING_ALLOCATION_MESSAGE:"Search Parking Allocation",
    SCAN_FOB_MESSAGE: "Click on the text field and tap the FOB to the scanner",
    TOKEN_ACTIVATION_MESSAGE: "This action will {0} the parking allocation for all the parkers associated with",
    DELETE_TOKEN_MESSAGE: "This action will delete the parking allocation for all the parkers associated with",
    ACTIVATION_ALLOCATION_MESSAGE: "This action will {0} the parking allocation only for this specific parker",
    REMOVE_PARKER_ALLOCATION_MESSAGE: "Remove parker from the parking allocation \nNo other parkers are assigned to this parking allocation, the allocation will be deleted",
    READY_TO_SEND_CAMPAIGN_MESSAGE: "Click button to choose recipients and send your campaign",
    READY_TO_SEND_REVIEW_MESSAGE: "Clicking the ‘Send’ button will send your campaign immediately without further confirmation",
    STEP: "Step",
    GREAT:"Great",
    LOGIN:"Login",
    FORGET_PASSWORD:"Forgot my password",
    SEND: "Send",
    SEND_AGAIN:"Send Again",
    SEND_FORGET_PASSWORD_EMAIL:"Send Me An E-mail",
    REMEMBRED_LOGIN:"Remembered? Login Here",
    RESET_PASSWORD:"Reset Password",
    PASSWORD:"Password",
    SAVE_NEW_PASSWORD:"Save",
    ADD_NEW_PARKER:"+ Add New Parker",
    ADD_RULE:"+ Add Billing Rule",
    ADD_EV_RULE:"+ Add EV Rule",
    PARKING_ALLOCATION: "+ Parking Allocation",
    CREATE_RULE:"Create Rule",
    CREATE_RATE:"Create Rate",
    ADD_CAMPAIGN: "+ New Campaign",
    ADD_MAILING_LIST: "+ New Mailing List",
    INVITE_GMT_USER: "+ Invite New GMT User",
    CHARGE_ACCOUNT: "+ Charge Account",
    FULL_VALIDATION: "Full Validation",
    PARTIAL_VALIDATION: "Partial Validation",
    SITE_COMMUNICATION: "Site Communication",
    TAX_RATES: "Tax Rates",
    PARKER_ACTIVATION_MESSAGE: "The sites marked will be activated for the parker.",
    DISACTVATE_PARKER_MESSAGE: "Are you sure you want to {0} this parker?",
    ACTIVATE_PERMISSION_MESSAGE: "Please select the permission you want to activate for {0}",
    ACTIVATE_PERMISSION_ONE_SCOPE_MESSAGE:"Please select the scope you want to activate {0} from:",
    DISACTIVE_PERMISSION_MESSAGE:"Please select the scopes you want to deactivate {0} from:",
    DELETE_PERMISSION_MESSAGE:"Are you sure that you want to remove {0} permissions for {1}?",
    DELETE_CAMPAIGN_MESSAGE:"Are you sure you want to delete the campaign?",
    DELETE_LIST_MESSAGE:"Are you sure you want to delete the list?",
    DISCARD_CHANGES_MESSAGE: "Are you sure you want to discard the changes?",
    RESET_FOB_MESSAGE: "Are you sure you want to reset the fob?",
    SKIP_FOB_MESSAGE: "Are you sure you want to skip the fob?",
    RESET_PASSWORD_MESSAGE:"Forgot your password? \n Let’s get you a new one!",
    RESET_PASSWORD_VALIDATION_MESSAGE:"This link is valid for 2 hours and can be used once.",
    RESET_PASSWORD_INSTRUCTION:"Enter new password and then repeat it",
    FORGET_PASSWORD_INSTRUCTION:"Enter your registered e-mail below to receive password reset instructions",
    LOGIN_INSTRUCTION:"Enter your credentials to access your account",
    PHONE_VERIFICATION_CODE:"Verification code will send to phone number that ends with :",
    INVALID_URL:"Reset Password - Invalid URL",
    RESET_URL_EXPIRED_HEADER: "Reset password link expired",
    RESET_URL_EXPIRED_DESCRIPTION: "Please request a new link",
    INVITATION_URL_EXPIRED_HEADER: "Invitation link expired",
    INVITATION_URL_EXPIRED_DESCRIPTION: "Please request a new link",
    FAILURE_UNSUBSCRIBED_HEADER: "Unsubscribe failure",
    FAILURE_UNSUBSCRIBED_DESCRIPTION: "Failed to unsubscribe",
    SUCCESSFULY_UNSUBSCRIBED_HEADER: "You have successfully unsubscribed!",
    SUCCESSFULY_UNSUBSCRIBED_DESCRIPTION: "We’re sad to see you go, but we respect your choice! You can change your decision at any time by re-subscribing on the Utron mobile app or by contacting the garage management.",
    SUCCESSFULY_ADDED_PARKER:"The new parker has been added to {0} Garage",
    SUCCESSFULY_DELETED_PARKER:"Parker deleted successfully",
    SUCCESSFULY_DELETED_CHARGE_ACCOUNT:"Charge account deleted successfully",
    SUCCESSFULY_ADDED_WORKSPACE: "Workspace added successfully",
    SUCCESSFULY_ADDED_BILLING_RULE: "Billing rule added successfully",
    SUCCESSFULY_DELETED_BILLING_RULE: "Billing rule deleted successfully",
    SUCCESSFULY_SAVE:"Your details have been saved successfully",
    SUCCESSFULY_EMAIL_SENT:"Email successfully sent. If you do not receive one shortly, please contact the support.",
    SUCCESSFULY_CAMPAIGN_SAVED: "You can edit, review and send your campaign any\n time through the ‘Campaigns’ tab",
    SUCCESSFULY_CAMPAIGN_SENT: "You can view your campaign details and delivery\n report any time through the ‘Messaging History’ tab",
    SUCCESSFULY_INVITATION_SENT: "Invitation was sent successfully",
    DELETE_CAR_USER_TOKEN_MESSAGE:"Are you sure that you want to delete token:{0}\n from:{1}?",
    CHANGED_SUCCESSFULY:"Changed successfully",
    SETUP_ACCOUNT:"Set Up My Account",
    SETUP_ACCOUNT_MESSAGE:"Let’s Set Up a new GMT user!",
    SETUP_COMPLETED_TITLE:"Set up completed successfully!",
    SETUP_COMPLETED_SUB_TITLE:"Log in to start using the system",
    SENFING_VERIFICATION_CODE:"A code has been send to your number. Please enter the confirmation code.",
    FILTER_TYPES:{
      QUICK_FILTER: "Quick Filter",
      CLEAR_ALL:"Clear All",
      PARKING_LOCATIONS:"Parking Locations",
      USER_TYPES:"User Types",
      PARKING:"Parking",
      SUBSCRIPTION_STATUS:"Subscription Status",
      DATE:"Date",
      CAMPAIGN_TYPES:"Campaign Types",
      VALIDATION_TYPES:"Validation Types",
      CHARGE_ACCOUNT:"Charge Account",
      OTHER:"Other",
    },
    TITLES:{
      DELETE_BILLING_RULE: "Delete Billing Rule",
      DELETE_CAR:"Delete Car",
      DELETE_USER:"Delete User",
      UNASSIGN_FACILITY:"Unassign Facility",
      TOKEN_OCCUPIED:"Token Occupied",
      ERROR: "Error",
      DISCARD_CHANGES: "Your changes will not be saved",
      UPDATE_SUCCESS: "Changes have been saved successfully",
      CREATE_SUCCESS: "Added Successfully",
      DELETE_SUCCESS: "Deleted Successfully",
      VALIDATE_PARKING_SUCCESS: "Validate Parking Completed",
      SAVE_CAMPAIGN_SUCCESS: "Your campaign was saved!",
      SEND_CAMPAIGN_SUCCESS: "Your campaign was successfully sent!",
      INVITATION_SUCCESS: "User Invited",
      PARKERS_PAGE:"Parkers",
      BILLING_PAGE:"Billing",
      ALLOCATIONS_PAGE: "Parking Allocations Management",
      VALIDATIONS_PAGE: "Validate Parking",
      HISTORY_PAGE: "Validation History",
      FREE_ALLOCATIONS: "Free Allocations",
      MESSAGING_PAGE: "Messaging",
      ADMIN_PAGE:"GMT Users",
      ACTIVATE_PERMISSION:"Are you sure that you want to activate {0}?",
      DISACTIVE_PERMISSION:"Are you sure that you want to deactivate {0}?",
      DELETE_PERMISSION:"Delete Permission",
      DELETE_CAMPAIGN: "Campaign will be permanently deleted",
      DELETE_LIST: "List will be permanently deleted",
      GMT_LOGIN:"GMT Login",
      ACTICITY:"Activity - Coming Soon",
      DELETE_CAR_USER_TOKEN:"Unoccupied Token",
      DELETE_TOKEN: "Delete Token",
      RESET_FOB: "Reset Fob",
      SKIP_FOB: "Skip Fob",
      REMOVE_PARKER_ALLOCATION: "Remove Parker",
      ACTIVATION_TOKEN: "{0} Token",
      ACTIVATION_ALLOCATION: "{0} Parking Allocation"
    },
    TOOLBAR_TITLE: {
      VALIDATION_HISTORY: "Total validation amount:",
      VALIDATION_HISTORY_SECONDARY: "Total number of validations:"
    },
    TOOLTIP_INFO_TITLE: {
      PERSONAL_ID: "Personal ID",
      PERSONAL_PIN: "PIN",
      PASSWORD: "Password",
      SEARCH_PARKING_ALLOCATION: "Search Parking Allocation",
      TOKENS_LIST: "Select Token",
      IS_PAYING: "Payment",
      CREATE_BILLING_RULE: "Create Billing Rule",
      ADD_RATE_LINE: "Rate lines",
      SITE_FULL_ADDRESS: "Site Full Address",
      USER_TYPE: "User Type",
      TEXT_MESSAGE: "Text Message",
      ATTACHMENT: "Attachment"
    },
    TOOLTIP_INFO_TEXT: {
      PERSONAL_ID: "Identification method (Username) for the kiosk stand. When needed to identify, insert this field to the kiosk.",
      PERSONAL_PIN: "Password for the kiosk. \nThis field will allow the parker to identify and park or retrieve the vehicle from the parking location.",
      PASSWORD: "Your password must contain at least: \n 8 characters \n One capitalized character \n One symbol, such as: !@#$%^&*()",
      SEARCH_PARKING_ALLOCATION: "Insert the phone number of one of the parkers that are assigned to the existing parking allocation.",
      TOKENS_LIST: "Each token in the list stands for one parking allocation. \nEach car must be assigned with one token per garage.",
      IS_PAYING: "Paying allocation will indicate if the parker should pay for parking or EV charging according to the the user type (and billing rules associated). \nThe payment will be done through the mobile app or kiosk.",
      CREATE_BILLING_RULE: `The order of the rates indicates the calculation order.
      Starting from the first rate until the last one.

      The rates total duration should sum up to the billing rule duration.
      
      To change the rates order, click and hold the 6-dots next to the rates and drag it to the new position.`,
      ADD_RATE_LINE: `Rate lines determines the $ amount in each time frame of the parking duration.
      Time frame – refers to 1 hour or 30 minutes
      
      Number of periods - repetition of the time frame (how many times the calculation refers to the rate).
      
      Example:
      Rate amount – $20
      Time Frame – 1 Hour
      Number of periods – 1
      
      The cost for the 1 Hour is $20 repeated 1 time (Number of periods).`,
      SITE_FULL_ADDRESS: "Defines the site full address",
      USER_TYPE: "Defines the user types of the workspace, Example: Tenants, VIP",
      TEXT_MESSAGE: "Invalid Characters: < >",
      ATTACHMENT: "Attachment size is limited to {0}KB"
    },
    VALIDATION_INSTRUCTIONS: {
      TITLE: "Instructions",
      STEP1: "Search user by entering the phone number / email used by the user for parking.",
      STEP2: "Once user is found, decide if to partial validate or fully validate the parking ticket.",
      STEP3: "Save.",
      INFO: "Guide the user to scan the QR received by a text message when the car was parked in the kiosk / order the car from the mobile application.\nThe updated parking fee will automatically show for the user to complete payment (if any)." 
    },
    USER_INFO: {
      FACILITY_AND_CAR: "Facility & Cars",
      FACILITIES_AND_ROLES: "Allowed Parking Scopes & Roles",
      HIDE: "Hide Cars",
      SHOW: "Show Cars",
    },
    PARKING_LABELS: {
      IN: "IN",
      OUT: "OUT",
      INACTIVE: "..",
    },
    PARKER_ACTIVATION_STATUS: {
      DISACTIVATE: "Deactivate parker",
      ACTIVATE: "Activate parker"
    },
    PARKERS_COLUMNS_NAMES: {
      NAME: "Name",
      APP: "App",
      PHONE_NUMBER: "Phone Number",
      EMAIL: "Email",
      NOTES: "Notes",
      SUBSCRIPTION_STATUS: "Subscription Status",
      TOKEN: "Token",
      WCA: "WCA",
      SITES: "Parking Locations",
      PARKING: "Parking",
      CARD: "Card",
      CAR_NUMBER: "Car Number",
      TIME: "Time",
      DURATION: "Duration",
      AMOUNT: "Amount",
      ELECTRIC: "Electric",
    },
    CAMPAIGN_COLUMNS_NAMES: {
      CAMPAIGN_NAME: "Campaign Name",
      DATE_CREATED: "Date Created",
      CAMPAIGN_TYPE: "Campaign Type",
      SITES: "Parking Facility"
    },
    MESSAGING_HISTORY_COLUMNS_NAMES: {
      CAMPAIGN_NAME: "Campaign Name",
      DATE_SENT: "Date Sent",
      CAMPAIGN_TYPE: "Campaign Type",
      NUMBER_OF_RECIPIENTS: "Number of Recipients",
      SITES: "Parking Facility",
      TOTAL: "Total"
    },
    MAILING_LISTS_COLUMNS_NAMES: {
      MAILING_LIST_NAME: "Mailing List Name",
      DATE_CREATED: "Date Created",
      SIZE: "Size (number of parkers)",
      SITES: "Parking Facility"
    },
    MESSAGING_PARKERS_COLUMNS_NAMES: {
      NAME: "Name",
      EMAIL: "Email",
      PHONE_NUMBER: "Phone Number",
      TYPE: "Type",
      SUBSCRIPTION_STATUS: "Subscription Status"
    },
    RECIPIENTS_COLUMNS_NAMES: {
      NAME: "Name",
      EMAIL: "Email",
      PHONE_NUMBER: "Phone Number",
      TYPE: "Type",
      STATUS: "Status",
      SUBSCRIPTION_STATUS: "Subscription Status",
      REASON: "Reason"
    },
    GMT_COLUMNS_NAMES: {
      NAME: "Name",
      PHONE_NUMBER: "Phone Number",
      EMAIL: "E-mail",
      SUBSCRIPTION_STATUS: "Subscription Status",
      SITES: "Parking Facility",
    },
    CHARGE_ACCOUNTS_COLUMNS_NAMES: {
      NAME: "Charge Account",
      EMAIL: "Main E-mail",
      CONTACT: "Contact",
      VALIDATION: "Validation",
      NOTES: "Notes"
    },
    BILLING_COLUMNS_NAMES: {
      RULE_NAME: "Rule Name",
      LAST_MODIFIED: "Last Modified",
      VALID_DAYS: "Valid Days",
      VALID_HOURS: "Valid Hours",
      USER_TYPES: "Assigned User Types",
      SITES: "Parking Locations",
      RATE: "Rate",
      OPTIONS: "Options"
    },
    OCCUPIED_COLUMNS_NAMES: {
      PARKING_ALLOCATION: "Parking Allocation - Token",
      PARKER_NAME: "Parker Name",
      ALLOCATION_TYPE: "Allocation Type",
      CAR_DETAILS: "Car Details",
      PARKING_LOCATIONS: "Parking Locations",
      PARKERS_FOB: "Parker's Fob"
    },
    HISTORY_COLUMNS_NAMES: {
      CHARGE_ACCOUNT: "Charge Account",
      DATE: "Date",
      VALIDATION_AMOUNT: "Validation Amount",
      VALIDATION_TYPE: "Validation Type",
      PHONE_NUMBER: "Phone Number",
      EMAIL: "Email"
    },
    TABS_NAMES: {
      DEATILS: "Details",
      HISTORY: "History",
      GUESTS: "Guests",
      OCCUPIED: "Occupied",
      PERMANENT: "Permanent Parkers",
      PUBLIC_PARKERS: "Public Parkers",
      CAMPAIGNS: "Campaigns",
      MESSAGING_HISTORY: "Messaging History",
      MAILING_LISTS: "Mailing Lists",
      GMT_USERS_MANAGMENT: "GMT User Management",
      CHARGE_ACCOUNTS: "Charge Accounts",
      ACTIVITY: "Activity",
      BILLING_RULES: "Billing Rules",
      EV_RULES: "EV Rules",
      VALIDATION_HISTORY: "Validation History"
    },
    INPUT_ERROR_MESSAGES: {
      IS_REQUIRED:"This field is mandatory",
      IS_NUMBER: "This field is numbers only",
      INVALID_EMAIL:"Email is not in correct format",
      INVALID_CAR_NICKNAME:"Invalid nickname, must contains at least one letter",
      INVALID_CAR_LICENSE:"This field can contain only letters or numbers",
      INVALID_PHONE:"Phone number is not in correct format",
      INVALID_SAME_PHONE: "You cannot use the same phone number as the selected user",
      UNMATCHED_PASSWORDS:"The passwords entered do not match",
      INVALID_INPUT: "This field can contain only letters",
      INVALID_PASSWORD:"Minimum 8 characters, at least one letter, one number and one special character",
      EMPTY_KIOSK_PIN: "New kiosk PIN cannot be empty",
      CODE_VERIFY_FAILURE: "The code entered is incorrect",
      CODE_TIME_EXPIRED: "Time expired, request new code",
      FOB_ALREADY_EXISTS: "FOB assigned to an existing parker",
      USER_NOT_FOUND: "User not found",
      PARKER_ALREADY_EXISTS: "Parker already exists",
      GMT_USER_NOT_FOUND: "Phone number inserted not associated with an existing parker",
      PHONE_NOT_VERIFIED: "Phone not verified",
      INVALID_FIELD: "Field is not in correct format",
      INVALID_LENGTH: "Field is too long",
      INVALID_LENGTH_CHAR: "Max field limit is {0}. Field cannot contain special characters, leading, trailing or extra blank spaces",
      INVALID_PASTED_LENGTH: "Content excceeds limit ({0} characters)",
      INVALID_NOTE: "Note is not in correct format",
      INVALID_BODY: "Body is not in correct format",
      INVALID_TEXT_MESSAGE: "Text Message contains invalid characters",
      INVALID_FILE_SIZE: "Exceeded file size limit {0}",
      INVALID_FILE_TYPE: "The file type is not supported"
    },
    MODAL_ERROR_MESSAGES: {
      KIOSK_LOGIN_NAME_ALREADY_EXISTS: "Kiosk ID already taken by another parker \n Enter a different Kiosk ID",
      PARKER_EMAIL_ALREADY_EXISTS: "Email entered is already associated with an existing parker, \n Please enter different email address",
      PARKER_PHONE_NUMBER_ALREADY_EXISTS: "Phone number entered is already associated with an existing parker, \n Please enter different phone number",
      REACHED_TOKENS_LIMIT: "Cannot add more than {0} parkers for a token",
      FIELD_VALUE_IS_MISSING: "One of the fields is missing",
      FOB_VALUE_IS_MISSING: "Fob value is missing",
      GMT_USER_EMAIL_ALREADY_EXISTS: "Email entered is already associated with an existing user, \n Please enter different email address",
      FINISH_PROCESS: "Process haven't been finished yet.",
      BILLING_REMAINING_TIME: "Please fill in rates to fit the billing rule duration",
      LOGIN_INVALID: "The email address or password is incorrect",
      NETWORK_TIMEOUT: "The request exceeded timeout limit",
      NETWORK_IS_DOWN: "The server is down or your connection is down"
    },
    INPUT_LABELS:{
      FIRST_NAME:"First Name*",
      LAST_NAME:"Last Name*",
      PHONE_NUMBER:"Phone Number*",
      EMAIL:"Email*",
      PERSIONAL_PIN:"Kiosk PIN",
      PERSIONAL_ID:"Kiosk ID",
      UPLOAD_PROFILE_IMAGE:"Upload Profile Image",
      CAR_NAME:"Car's Name*",
      LICENCE_PLATE:"Licence Plate*",
      COLOR:"Color",
      MANUFACTURE:"Manufacture",
      VEHICLE_TYPE: "Vehicle Type",
      ASSIGN_TOKENS:"Assign Tokens",
      EV_CHARGING:"EV Charging",
      CHARGING_POSITION: "Charging Position",
      ADA:"ADA Car",
      APP:"U-tron App",
      OLD_PIN:"Kiosk PIN",
      NEW_PIN:"New Kiosk PIN",
      VERIFY_NEW_PIN:"Confirm Kiosk PIN",
      NOTES: "Notes",
      TOKEN:"Token",
      FOB_SCAN:"Fob Scan",
      PASSWORD:"Password*",
      CURRENT_PASSWORD:"Current Password*",
      NEW_PASSWORD:"New Password",
      REPEAT_PASSWORD: "Repeat Password",
      FACILITY: "Facility",
      BILLING_USER_TYPE: "User Type Selection",
      RULE_NAME: "Rule Name",
      RULE_START_TIME: "Start",
      RULE_FINISH_TIME: "Finish",
      COST_PER_KV: "Cost per kW",
      RATE_AMOUNT: "Rate Amount",
      CHARGE_BY: "Charge By",
      NUMBER_OF_PERIODS: "Number of Periods",
      NEW_SCOPE_NAME: "New Scope Name", 
      NEW_SITE_NAME: "New Site Name", 
      SCOPE_TYPE: "Scope Type",
      SITE_TECH: "Site Technology",
      SELECT_EXISTING_SCOPE: "Select Existing Scope",
      MAILING_LIST_NAME: "Mailing List Name",
      MAILING_LIST_PARKERS: "Mailing List Parkers",
      MAILING_LIST_ADD_PARKERS: "Add parkers",
      CAMPAIGN_TYPE: "Campaign Type",
      CAMPAIGN_NAME: "Campaign Name",
      EMAIL_SUBJECT: "Email Subject",
      EMAIL_BODY: "Email Body",
      TEXT_BODY: "Text Message",
      LINK: "Link",
      GENERATED_LINK: "Generated Link",
      ATTACHMENT: "Attachment",
      RECIPIENTS: "Recipients",
      CHARGE_ACCOUNT_NAME: "Charge Account Name",
      CONTACT_NAME: "Contact Name",
      CONTACT_FIRSTNAME: "Contact First Name",
      CONTACT_LASTNAME: "Contact Last Name",
      PAYMENT_DISTRIBUTION: "Payment Distribution",
      LICENSE_NUMBER: "License Number",
      TIMEZONE: "Time Zone", 
      REGION: "Region",
      APMS_IOT_DEVICE_NAME: "Apms IOT Device Name",
      HEALTH_CHECK_IOT_DEVICE_NAME: "Health Check IOT Device Name",
      PARKING_TAX_RATE: "Parking Tax Rate (%)",
      EV_TAX_RATE: "Ev Tax Rate (%)",
      CURRENCY: "Currency", 
      DISCOUNT_TYPE: "Type",
      AMOUNT: "Amount",
      VALIDATION_TYPE: "Validation",
      SITE_DISPLAY_NAME: "Site Display Name", 
      SITE_FULL_ADDRESS: "Site Full Address", 
      USER_TYPE_NAME: "User Type Name", 
      DAILY_MAX: "Daily Max",
      SEARCH_PARKER: "Search Parker",
      START_DATE: "Start Date",
      END_DATE: "End Date"
    },
    STEPS_TITLES:{
      WORKSPACE: "Workspace", 
      WORKSPACE_ACTIONS_TITLE: "Workspace Actions",
      WORKSPACE_ACTIONS_DEFAULT_SUB_TITLE: "Select an action for workspace",
      WORKSPACE_ACTIONS_ADD_SUB_TITLE: "Add new workspace", 
      WORKSPACE_ACTIONS_EDIT_SUB_TITLE: "Edit existing workspace",
      WORKSPACE_SCOPE_DETAILS_TITLE: "Scope Details",
      WORKSPACE_SCOPE_DETAILS_DEFAULT_SUB_TITLE: "Select if this is a stand-alone site or a site under an existing scope",
      WORKSPACE_SCOPE_DETAILS_NEW_SUB_TITLE: "Add new scope name", 
      WORKSPACE_SCOPE_DETAILS_EXISTING_SUB_TITLE: "Select existing scope", 
      WORKSPACE_GENERAL_DETAILS_TITLE: "General Details", 
      WORKSPACE_GENERAL_DETAILS_SUB_TITLE: "Please add all relevant information regarding the site contact user and garage general details", 
      WORKSPACE_TECH_TITLE: "Technology and Parking spaces",
      WORKSPACE_TECH_SUB_TITLE: "Select site technology, number of parking spaces and vehicle type division",
      WORKSPACE_PRODUCTS_TITLE: "Products",
      WORKSPACE_ADDITIONAL_INFO_TITLE: "Additional Info",
      WORKSPACE_USER_TYPES_TITLE: "User Types", 
      WORKSPACE_USER_TYPES_SUB_TITLE: "Define users type for the new site",
      WORKSPACE_ADD_USER_TYPE_TITLE: "Add User Type",
      WORKSPACE_ADD_USER_TYPE_SUB_TITLE: "Define user type name and MAX daily payment",
      WORKSPACE_SUMMARY_TITLE: "Workspace Summary",
      WORKSPACE_SUMMARY_SUB_TITLE: "Verify all details",
      GENERAL_DETAILS_MODAL_TITLE: "Create New Parker",
      GENERAL_DETAILS_EDIT_MODAL_TITLE: "Edit Parker’s Details",
      GENERAL_DETAILS_MODAL_SUB_TITLE: "Step 1",
      GENERAL_DETAILS_EDIT_MODAL_SUB_TITLE: "Please fill in the fields you wish to edit and click on ‘Save changes’ once completed",
      GENERAL_DETAILS_TITLE: "General Details",
      GENERAL_DETAILS_SUB_TITLE:"Please fill in the parker’s general details",
      GENERAL_DETAILS_SUB_TITLE_GMT_USER:"Select the phone number of the GMT user you wish to grant parking permissions to",
      USER_TYPE_MODAL_TITLE: "Create New Parker",
      USER_TYPE_MODAL_SUB_TITLE: "Step 2",
      USER_TYPE_EDIT_MODAL_TITLE: "Manage parking facilities",
      USER_TYPE_TITLE: "Parking Facility",
      USER_TYPE_SUB_TITLE:"Select the parking facility and user type for the parker",
      USER_TYPE_NO_AVAILABLE_FACILITIES_SUB_TITLE: "There is no available parking facilities to add for this user",
      USER_TYPE_MODAL_ADD_ALLOCATION_TITLE: "Select facility & user type",
      USER_TYPE_MODAL_ADD_ALLOCATION_SUB_TITLE: "Step 1",
      ADD_CARS_MODAL_TITLE: "Add Car",
      EDIT_CARS_MODAL_TITLE: "Edit Car",
      ADD_CARS_MODAL_SUB_TITLE: "Step 4",
      ADD_CARS_TITLE: "Add New Car",
      ADD_ADDITIONAL_CAR_TITLE: "Add an additional car",
      ADD_CARS_SUB_TITLE:"",
      ADD_ALLOCATION_TITLE: "Parking Allocation",
      ADD_TOKEN_MODAL_TITLE:"Add Parking Allocation",
      ADD_TOKEN_MODAL_SUB_TITLE:"Step 3",
      ADD_TOKEN_TITLE:"Add Parking Allocation",
      ADD_TOKEN_SUB_TITLE:"Create a new parking allocation for the parker or add the parker to an existing parking allocation",
      ADD_TOKEN_MODAL_ADD_ALLOCATION_TITLE:"Add Parking Allocation",
      ADD_TOKEN_MODAL_ADD_ALLOCATION_SUB_TITLE:"Step 2",
      ALLOCATION_MANAGEMENT_INFO_TITLE: "Parking Allocation Management",
      ADD_BILLING_RULE_MODAL_TITLE: "Create New Billing Rule",
      ADD_BILLING_RULE_TITLE: "Add Billing Rule",
      ADD_BILLING_RULE_SUB_TITLE: "Choose the user types to create this billing rule for and create different rates",
      ADD_EV_RULE_MODAL_TITLE:"Add New EV Rule",
      ADD_EV_RULE_TITLE: "Add EV Rule",
      ADD_EV_RULE_SUB_TITLE: "Add a new electrical vehicle charging rule",
      ADD_RATE_TITLE: "Add Rate Line",
      ADD_RATE_SUB_TITLE: "Each rate presents a different rate for the same billing rule",
      EDIT_BILLING_RULE_MODAL_TITLE: "Edit Billing Rule",
      EDIT_BILLING_RULE_TITLE: "Edit Billing Rule",
      EDIT_EV_RULE_MODAL_TITLE: "Edit EV Rule",
      EDIT_EV_RULE_TITLE: "Edit EV Rule",
      EDIT_PROFILE_DETAILS_TITLE:"Edit Profile Details",
      EDIT_PROFILE_DETAILS_SUB_TITLE:"Edit the details and click on Save Changes",
      USER_ROLE_MODAL_TITLE: "Add Permissions",
      USER_ROLE_EDIT_MODAL_TITLE: "Edit Permissions",
      USER_ROLE_MODAL_SUB_TITLE: "Lorem ipsum dolor sit amet, consectetur adipiscing.",
      USER_ROLE_EDIT_MODAL_SUB_TITLE: "Lorem ipsum dolor sit amet, consectetur adipiscing.",
      USER_ROLE_TITLE: "Add Facility Permissions",
      USER_ROLE_EDIT_TITLE: "Edit Facility Permissions",
      USER_ROLE_NO_AVAILABLE_FACILITIES_SUB_TITLE: "There is no available facility permissions to add for this user",
      USER_ROLE_SUB_EDIT_TITLE:"Each permission type grands the user with different permissions in the system",
      INVITE_NEW_GMT_MODAL_TITLE:"Invite new GMT user",
      INVITE_NEW_GMT_MODAL_SUB_TITLE:"Please fill in all of the user’s general details",
      CREATE_NEW_CHARGE_ACCOUNT_TITLE: "Create new charge account",
      EDIT_CHARGE_ACCOUNT_TITLE: "Edit charge account",
      CHARGE_ACCOUNT_SUB_TITLE: "Please fill in all details",
      CREATE_NEW_CAMPAIGN_TITLE: "Create New Campaign",
      RECIPIENTS_CAMPAIGN_TITLE: "Recipients",
      CREATE_NEW_MAILING_LIST_TITLE: "Create New Mailing List",
      EDIT_MAILING_LIST_TITLE: "Edit Mailing List",
      MAILING_LIST_DETAILS_TITLE: "Choose parkers",
      MAILING_LIST_DETAILS_SUB_TITLE: "Select the parkers you would want to add to your mailing list",
      CAMPAIGN_DETAILS_NEW_TITLE: "New Campaign",
      CAMPAIGN_DETAILS_EDIT_TITLE: "Edit Campaign",
      CAMPAIGN_DETAILS_DUPLICATE_TITLE: "Duplicate Campaign",
      RECIPIENTS_TITLE: "Choose Recipients",
      RECIPIENTS_SUB_TITLE: "Send this campaign to your mailing lists and parkers",
      CAMPAIGN_REVIEW_TITLE: "Review Campaign",
      ATTACHMENT_TITLE: "Attachment",
      VALIDATIONS_TITLE: "Validations",
      ASSIGN_TITLE:"Assign",
      ASSIGN_SUB_TITLE:"Assign the user to a specific site (facility) or to a general scope (which contains several sites)",
      SEARCH_PARKER_TITLE: "Search for parker",
      SEARCH_PARKER_SUB_TITLE: "Search for the parker that will be assigned to the parking allocation"
    },
    TEMPLATES: {
      RECEIPT_EMAIL: "Hi {2} \nFollow this link to view receipts for parking at the `{0}` garage \n{1} \nThank you for parking with us, \n`{0}` facility managment."
      //RECEIPT_EMAIL: "{0} Parking Receipts \n {1} \n  Hi {2} \n Please find attached your receipts for parking at the {0} parking facility.\n Thank you for parking with us!\n {0} facility managment."
    }
  },
  he: {
    GOOD_MORNING: "בוקר טוב",
    GOOD_AFTERNOON: "אחה הצהרים טובים",
    GOOD_EVENING: "ערב טוב",
  },
};

export default new LocalizedStrings(Strings);
